<template>
  <v-dialog :value="value" persistent width="500">
      <v-card class="fill">
        <v-card-title class="text-subtitle-1">
          <v-icon x-large left color="primary">mdi-help-rhombus</v-icon>
          Remove {{selected.length > 1 ? `${selected.length} items` : `${selected.length} item`}}?
        </v-card-title>
        <v-card-text class="py-8">
          <v-row justify="center">
            This action will remove all selected contract items from contract.
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn :class="body" rounded text @click="$emit('cancel'), $emit('update:value', false)">
            Cancel
          </v-btn>
          <v-btn rounded :class="body" class="green white--text ml-2" @click="confirm">
            Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { displayHelpers } from '@/mixins/display-helpers'
export default {
  name: 'ItemDelete',

  props: {
    value: Boolean,
    selected: Array
  },

  mixins: [displayHelpers],

  methods: {
    confirm () {
      this.$emit('remove')
      this.$emit('update:value', false)
    }
  }
}
</script>
